module.exports = __webpack_public_path__ + "static/img/active2.21765d9b.png";